module.exports = __webpack_public_path__ + "media/images/font/Gustavo-Bold-a09be109a1d6eb2ef0db83b90822d328.woff2";